export default "__VITE_ASSET__B2hu$jmA__"